var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelfie(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.166 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.05,
    height: 29.536,
    rx: 4,
    fill: "#fff",
    stroke: "#707070",
    "data-name": "Rect\\xE1ngulo 5960"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3.9168,
    width: 16.166,
    height: 16.166,
    fill: "none",
    strokeWidth: 0.5052,
    "data-name": "Rect\\xE1ngulo 5564"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.74917 0 0 .74917 .0864 .013317)",
    "data-name": "Grupo 18652"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Movil_Dispositivo_Terminales_2Regular"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-116.9)",
    d: "m132.9 32h-10.651a5.43 5.43 0 0 1-4.006-1.32 5.4 5.4 0 0 1-1.343-4.028v-21.303a5.387 5.387 0 0 1 1.338-3.978 5.361 5.361 0 0 1 4.011-1.371h10.651a5.384 5.384 0 0 1 4.015 1.343 5.4 5.4 0 0 1 1.334 4.006v21.3a5.416 5.416 0 0 1-1.343 4.028 5.437 5.437 0 0 1-4.006 1.323zm-10.651-30.179c-2.5 0-3.528 1.024-3.528 3.528v21.3c0 2.572 0.956 3.528 3.528 3.528h10.651c2.572 0 3.528-0.956 3.528-3.528v-21.3a3.756 3.756 0 0 0-0.8-2.722 3.733 3.733 0 0 0-2.727-0.806z",
    "data-name": "Trazado 24135"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-312.38 -524.96)",
    d: "m323.05 550a1.222 1.222 0 0 0-1.352 1.356 1.355 1.355 0 1 0 2.7 0 1.224 1.224 0 0 0-1.348-1.356z",
    "data-name": "Trazado 24136"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-302.93 -515.52)",
    d: "m313.6 543.72a1.669 1.669 0 0 1-1.8-1.812 1.805 1.805 0 1 1 3.61 0 1.669 1.669 0 0 1-1.807 1.812zm0-2.713c-0.619 0-0.9 0.278-0.9 0.9a0.952 0.952 0 0 0 0.209 0.678 0.937 0.937 0 0 0 0.683 0.223 0.907 0.907 0 0 0 0.683-0.223 0.954 0.954 0 0 0 0.209-0.678c0.011-0.622-0.262-0.904-0.884-0.9z",
    "data-name": "Trazado 24137"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.64,1.013)",
    clipPath: "url(#a)",
    "data-name": "Enmascarar grupo 42"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.189,2.458)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Usuario_Micuenta_persona_2Regular"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-38.9)",
    d: "m51.251 13.912a7.075 7.075 0 0 1-5.094-1.719 6.966 6.966 0 0 1-1.857-5.229 6.992 6.992 0 0 1 1.854-5.237 7.061 7.061 0 0 1 5.097-1.727 7.087 7.087 0 0 1 5.1 1.727 6.964 6.964 0 0 1 1.861 5.237 6.94 6.94 0 0 1-1.865 5.229 7.085 7.085 0 0 1-5.096 1.719zm0-12.331a5.561 5.561 0 0 0-4 1.284 5.507 5.507 0 0 0-1.371 4.1 5.472 5.472 0 0 0 1.371 4.091 5.582 5.582 0 0 0 4 1.277 5.627 5.627 0 0 0 4.008-1.277 5.46 5.46 0 0 0 1.379-4.087c-4e-3 -3.625-1.767-5.388-5.387-5.388zm11.56 26.2h-23.121a0.793 0.793 0 0 1-0.79-0.79v-2.309a7.684 7.684 0 0 1 1.992-5.458 8.211 8.211 0 0 1 6.108-2.269h8.48a8.228 8.228 0 0 1 6.12 2.265 7.673 7.673 0 0 1 2 5.462v2.312a0.793 0.793 0 0 1-0.789 0.79zm-22.33-1.581h21.539v-1.518a6.153 6.153 0 0 0-1.561-4.367 6.626 6.626 0 0 0-4.98-1.778h-8.479a6.585 6.585 0 0 0-4.968 1.778 6.153 6.153 0 0 0-1.553 4.367z",
    fill: "#fff",
    "data-name": "Trazado 24131"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfie);
export default __webpack_public_path__ + "static/media/Selfie.f4104d1f21abfb4493f6e84e9edba22f.svg";
export { ForwardRef as ReactComponent };